<template>
  <div>
    <top-head />
    <video-part></video-part>
    <title-bar title="Betta Employees"></title-bar> 
    <!-- 员工风采 -->
    <div class="people-box">
      <el-row>
        <el-col :span="8">
          <img src="../../../static/images/life/people1.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people2.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people3.jpg">
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <img src="../../../static/images/life/people4.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people5.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people6.jpg">
        </el-col>
      </el-row>
    </div>
    <div class="word-box">
      <img src="../../../static/images/life/wordbg.jpg" />
      <div class="word-center-box">
        <div class="word-center">
          <div class="word-title">
            BE BETTA BE BETTER
          </div>
          <div class="word-content">
            Betta Games is committed to "BE BETTA BE BETTER" employer brand proposition, adhere to the simple, fast and responsible work concept, to provide its game talents with generous value rewards, perfect welfare protection and the organization culture space of seeking truth and encouraging innovation, so as to truly welcome the outstanding talents who love the game industry and are full of entrepreneurial passion, maximize their talents, realize their career Dreams, create a better life, in order to finally achieve the beautiful vision of ten million daily activities, billion of smiling faces.
          </div>
        </div>
      </div>
    </div>
    <div class="spread-box">
      <el-row>
        <el-col :span="16">
          <img v-show="imgSwitch == 1" src="../../../static/images/life/spread1-1.jpg" />
          <img v-show="imgSwitch == 2" src="../../../static/images/life/spread1-2.jpg" />
          <img v-show="imgSwitch == 3" src="../../../static/images/life/spread1-3.jpg" />
        </el-col>
        <el-col :span="8" class="spread-word">
            <div class="spreadBox">
                <div class="spread-word-title">BETTA PARTY</div>
                <div class="spread-word-content">Interest Groups, Birthday Parties, Holiday Presents and Health Insurance for Every Employee. Happy Working, Happy Life.</div>
            </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" class="spread-img-right">
          <img v-show="imgSwitch == 1" src="../../../static/images/life/spread2-1.jpg" />
          <img v-show="imgSwitch == 2" src="../../../static/images/life/spread2-2.jpg" />
          <img v-show="imgSwitch == 3" src="../../../static/images/life/spread2-3.jpg" />
        </el-col>
        <el-col :span="8" class="spread-word spread-word2">
            <div class="spreadBox">
                <div v-show="imgSwitch == 1" class="spread-word-title">Basic Welfare</div>
                <div v-show="imgSwitch == 1" class="spread-word-content">"Let the care be meticulous, let the benefits fall into place“ Best social insurance and public housing fund, annual physical examination, meal stipend, afternoon tea, snacks and more. All of them is to ensure that the benefits are rich enough, comprehensive and practical.</div>
                <div v-show="imgSwitch == 2" class="spread-word-title">Personalised Welfare</div>
                <div v-show="imgSwitch == 2" class="spread-word-content">
                    In addition to basic benefits, we are building a benefits a welfare platform to meet employees' individual needs for housing, education, food, and risk protection for children, parents, and spouses.</div>
                <div v-show="imgSwitch == 3" class="spread-word-title">BEAUTIFUL LIFE</div>
                <div v-show="imgSwitch == 3" class="spread-word-content">We have made special personalised arrangements of benefits such as equity incentives, high-end medical care, family trips, long-term contribution awards, and lifelong growth and learning funds. In order to show our gratitude and give back to the staff and the Betta family.</div>
            </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <img v-show="imgSwitch == 1" src="../../../static/images/life/spread3-1.jpg" />
          <img v-show="imgSwitch == 2" src="../../../static/images/life/spread3-2.jpg" />
          <img v-show="imgSwitch == 3" src="../../../static/images/life/spread3-3.jpg" />
        </el-col>
        <el-col :span="8" class="spread-word">
            <div class="spreadBox" style="width:250px;">
                <div class="spread-word-title">Team Building</div>
                <div class="spread-word-content">Exclusive group building allowance. More love, more fun.</div>
            </div>
        </el-col>
      </el-row>
    </div>
    <homeFoot />
  </div>
</template>
<script>
  import topHead from '../parts/headPart';
  import homeFoot from '../parts/homeFoot.vue';
  import videoPart from '../parts/life/videoPart.vue';
  import TitleBar from '../common/title-bar.vue';

  export default {
    name: 'life',
    components: {
      topHead,
      homeFoot,
      videoPart,
      TitleBar
    },
    data() {
      return {
        imgSwitch: 1
      }
    },
    mounted() {
      setInterval(() => {
        if (this.imgSwitch == 3) {
          this.imgSwitch = 1
        } else {
          this.imgSwitch += 1
        }
      }, 7000)
    }
  }
</script>
<style scoped lang="less">
  .people-box {
    width: 100%;

    img {
      width: 100%;
      vertical-align: middle;
    }
  }

  .word-box {
    width: 100%;
    color: #fff;
    position: relative;

    img {
      width: 100%;
      vertical-align: middle;
    }

    .word-center-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .word-title {
        font-size: 36px;
        line-height: 36px;
      }

      .word-content {
        font-size: 18px;
        width: 1080px;
        margin: 0 auto;
        margin-top: 50px;
        line-height: 32px;
      }
    }
  }

  .spread-box {
    width: 100%;

    img {
      width: 100%;
      min-width: 976px;
      vertical-align: middle;
    }

    .spread-word {
      height: 100%;
      position: absolute;
      right: 0;
      background-color: #47A3E4;
      color: #fff;
      text-align: left;
      display: flex;
      justify-content: center;
      flex-direction: column;
        .spreadBox{
            height:100%;
            margin: 50% auto;
            width:340px;
        }
      .spread-word-title {
        font-size: 28px;
        line-height: 28px;
      }

      .spread-word-content {
        width: 340px;
        font-size: 16px;
        line-height: 32px;
        margin-top: 18px;
      }
    }

    .spread-word2 {
      left: 0;

      .spread-word-title {
        font-size: 28px;
        line-height: 28px;
      }

      .spread-word-content {
        width: 340px;
        font-size: 16px;
        line-height: 32px;
        margin-top: 18px;
      }
    }

    .spread-img-right {
      float: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/life.vue